import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStore } from "effector-react";
import { $isLoggedIn } from "../../../../entities/user/model";
import { URLS } from "../router";

export function PrivateOutlet() {
  const isLoggedIn = useStore($isLoggedIn);
  // const isLoggedIn = true;

  return isLoggedIn ? <Outlet /> : <Navigate to={URLS.LOGIN} />;
}
